import React, { useEffect, useState } from 'react';
import Header from '../../components/header/Header';
import LoaderComponent from '../../components/Loader.component';
import serverStore from '../../../stores/server.store';
import ServersDashboard from './components/ServersDashboard';
import tagsStore from '../../../stores/tags.store';
import uptimeStore from '../../../stores/uptime.store';
import mongoDbStore from '../../../stores/mongodb.store';
import WhatsNewModal from '../../components/modal/WhatsNewModal';
import { addToast } from '../../components/toasts/Toast';

const ServersPage = () => {
    document.title = 'Servers - SyAgent';

    const [loader, setLoader] = useState(true);
    const [showWhatsNew, setShowWhatsNew] = useState(false);

    useEffect(() => {
        const getData = async () => {
            try {
                await Promise.all([
                    serverStore.getServers(),
                    tagsStore.getTags(),
                    uptimeStore.getUptime(),
                    mongoDbStore.getMongoDb()
                ]);

                const hasSeen = localStorage.getItem('seenWhatsNew_v1.0');
                if (!hasSeen) {
                    setShowWhatsNew(true);
                }
            } catch (error) {
                addToast(error.message || 'Failed to load monitors', 'error');
            } finally {
                setLoader(false);
            }
        };

        getData();
    }, []);

    const handleCloseWhatsNew = () => {
        localStorage.setItem('seenWhatsNew_v1.0', 'true');
        setShowWhatsNew(false);
    };

    return (
        <main className="servers">
            <Header/>
            { loader && (
                <LoaderComponent/>
            ) }
            { !loader && (
                <>
                    <ServersDashboard/>
                    { showWhatsNew && (
                        <WhatsNewModal close={ handleCloseWhatsNew } />
                    ) }
                </>
            ) }
        </main>
    );
};

export default ServersPage;
